import { __require as t } from "./_nativeCreate.js";
var r, a;
function h() {
  if (a) return r;
  a = 1;
  var e = t();
  function i() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return r = i, r;
}
export {
  h as __require
};
